export default theme => ({ // eslint-disable-line
    backgroundImageContainer: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: 1,
        '& > div': {
            backgroundColor: 'transparent !important',
        }
    }
})